    $(document).ready(function () {
        var kt8HeaderMenu;
        $('.kt8-header-menu-ul .kt8-header-menu-li').each(function (i) {
            if (kt8HeaderMenu == null) {
                kt8HeaderMenu = $(this).prop('outerHTML');
            } else {
                kt8HeaderMenu = kt8HeaderMenu + $(this).prop('outerHTML');
            }
        });        
        
        if (kt8HeaderMenu == null) {
            // Retrieve the object from storage
            var kt8LocalHeaderMenu = sessionStorage.getItem('kt8_header_menu') != null ? JSON.parse(sessionStorage.getItem('kt8_header_menu')) : null;

            if (kt8LocalHeaderMenu != null) {
                $(".kt8-header-menu-ul").prepend(kt8LocalHeaderMenu);
            } else {
                 $(".kt8-header-menu-ul").prepend($('.kt8-default-home-menu').html());
            }
        } else {
            // Put the object into storage    
            // sessionStorage.removeItem("kt8_collection_logo");
            sessionStorage.setItem('kt8_header_menu', JSON.stringify(kt8HeaderMenu));
        }


        // var kt8SocialMenu;
        // $('.kt8-social-menu-ul .kt8-social-menu-li').each(function (i) {
        //     if (kt8SocialMenu == null) {
        //         kt8SocialMenu = $(this).prop('outerHTML');
        //     } else {
        //         kt8SocialMenu = kt8SocialMenu + $(this).prop('outerHTML');
        //     }
        // });        
        
        // if (kt8SocialMenu == null) {
        //     // Retrieve the object from storage
        //     var kt8LocalSocialMenu = sessionStorage.getItem('kt8_social_menu') != null ? JSON.parse(sessionStorage.getItem('kt8_social_menu')) : null;

        //     if (kt8LocalSocialMenu != null) {
        //         $(".kt8-local-menu-ul").prepend(kt8LocalSocialMenu);
        //     } else {
        //          $(".kt8-local-menu-ul").prepend($('.kt8-default-social-menu').html());
        //     }
        // } else {
        //     // Put the object into storage    
        //     sessionStorage.setItem('kt8_social_menu', JSON.stringify(kt8SocialMenu));
        // }

        //KT8 collection logo/title
        var kt8CollectionLogo = $('.kt8-header-logo').html();
        
        if ((window.location.href.indexOf("/products/") > -1) || (window.location.href.indexOf("/collections/") > -1)) {          
            sessionStorage.setItem('kt8_collection_logo', JSON.stringify(kt8CollectionLogo));
        } else {
          var localKt8CollectionLogo = sessionStorage.getItem('kt8_collection_logo') != null ? JSON.parse(sessionStorage.getItem('kt8_collection_logo')) : null;

          if (localKt8CollectionLogo != null) {
            $('.kt8-header-logo').html(localKt8CollectionLogo);
          } else {
            $('.kt8-header-logo .kt8-header-collection-title-h2').html('KT8 Merch Co');
          }
        }

      //Announcement bar
      var kt8CollectionAnnouncement = $('#shopify-section-section-announcement-bar').html();
      if ((window.location.href.indexOf("/products/") > -1) || (window.location.href.indexOf("/collections/") > -1)) {          
            sessionStorage.setItem('kt8-announcement-bar', JSON.stringify(kt8CollectionAnnouncement));
        } else {
          var localKt8CollectionAnnouncement = sessionStorage.getItem('kt8-announcement-bar') != null ? JSON.parse(sessionStorage.getItem('kt8-announcement-bar')) : null;

          if (localKt8CollectionAnnouncement != null) {
            $('#shopify-section-section-announcement-bar').html(localKt8CollectionAnnouncement);
          }
        }
    });